import { render, staticRenderFns } from "./CartPage.vue?vue&type=template&id=04a3e247&scoped=true&"
import script from "./CartPage.vue?vue&type=script&lang=js&"
export * from "./CartPage.vue?vue&type=script&lang=js&"
import style0 from "./CartPage.vue?vue&type=style&index=0&id=04a3e247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3e247",
  null
  
)

export default component.exports